import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { StoreFeatures } from '@state/store.utils';
import { CmsActions } from '@state/cms/cms.actions';
import { CmsPageUrl, Widget } from '@core/models';

export type CmsState = {
  pageWidgets: { [url in CmsPageUrl]?: Widget[] };
};

export const initialCmsState: CmsState = {
  pageWidgets: {},
};

export const cmsReducer = createReducer(
  initialCmsState,
  on(CmsActions.getPageWidgetsSuccess, (state, { url, widgets }): CmsState => {
    const pageWidgets = { ...state.pageWidgets };
    pageWidgets[url] = widgets;
    return {
      ...state,
      pageWidgets,
    };
  })
);

export const cmsFeature = createFeature({
  name: StoreFeatures.Cms,
  reducer: cmsReducer,
  extraSelectors: ({ selectPageWidgets }) => ({
    selectPageWidget: (url: CmsPageUrl) =>
      createSelector(
        selectPageWidgets,
        (query) => (query?.[url] ?? []) as Widget[]
      ),
  }),
});
